// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDnfLx0BfIBQQ-NhBDGgcxscwYOCrUyvqQ",
  authDomain: "test-dda81.firebaseapp.com",
  databaseURL: "https://test-dda81-default-rtdb.firebaseio.com",
  projectId: "test-dda81",
  storageBucket: "test-dda81.firebasestorage.app",
  messagingSenderId: "463898180702",
  appId: "1:463898180702:web:4bf9ab254093f4d5adc8cf",
  measurementId: "G-MQCWZLWDHH"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
